import React from "react";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { FontSizeWidth } from "../../utility/constant";
import { useSelector } from "react-redux";
import { selectWidth } from "../../utility/Redux/profile";
const valueInput = (v) => {
  if (v > 0) {
    return FormatNumber2(v);
  } else {
    return "";
  }
};
const Footer = ({ columns, rows, isFeilds }) => {
  const width = useSelector(selectWidth);
  if (!isFeilds) {
    return (
      <div className="flex  w-full mt-1">
        <div className="flex">
          {columns.map((e, i) => {
            return (
              <div
                key={i}
                style={{
                  width: e.width,
                  borderLeft: i === 0 ? "1px solid black" : "1px solid black",
                  borderRight:
                    i === columns.length - 1
                      ? "1px solid black"
                      : "0px solid black",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  fontSize: FontSizeWidth(width),
                }}
                className="p-1 text-right "
              >
                {e.field === "NAME" && "Total"}

                {e.field === "AMOUNT" &&
                  valueInput(
                    rows.reduce((acc, row) => acc + Number(row.AMOUNT), 0)
                  )}
                {e.field === "QNTY" &&
                  rows.reduce((acc, row) => acc + Number(row.QNTY), 0)}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return <div>{isFeilds}</div>;
  }
};

export default Footer;
